export default (request, entities, translators) => ({
  create(charge) {
    const transaction = charge.transaction.id ? charge.transaction.id : charge.transaction;
    const data = translators.Charge.toServer(charge);
    return request('POST', `transactions/${transaction}/charges`, data)
      .then(translators.Charge.fromServer);
  },
});
